import moment from 'moment-timezone'

export const pdfTemplate = (
  data,
  registrationNumberColor = `#fff`,
  grayColor = `#ADB6C9`,
) => `<html>
<body>
  <div>
    <div
      style="
        position: relative;
        background-color: #fff;
        width: 100%;
        height: 842px;
        overflow: hidden;
        text-align: left;
        font-size: 14px;
        color: #8a8d97;
        font-family: 'Scoutie Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      "
    >
      <div
        style="
          width: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        "
      >
        <div
          style="
            background-color: #f3790e;
            width: 100%;
            height: 44px;
            overflow: hidden;
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            padding: 10px 12px;
            box-sizing: border-box;
            align-items: center;
            justify-content: space-between;
            position: relative;
            font-size: 10px;
            color: #fff;
          "
        >
          <div
            style="
              margin: 0 !important;
              position: absolute;
              top: 0px;
              left: 0px;
              display: flex;
              flex-direction: row;
              width: 100%;
              z-index: 0;
            "
          >
            <img
              style="
                position: relative;
                height: 44px;
                overflow: hidden;
                flex-shrink: 0;
                mix-blend-mode: soft-light;
              "
              src="https://nos.wjv-1.neo.id/moflip-bucket/jakmania-app/pdf-top-texture.svg"
            />
          </div>
          <img
            style="
              position: relative;
              width: 80px;
              height: 32px;
              object-fit: cover;
              z-index: 1;
            "
            alt=""
            src="https://nos.wjv-1.neo.id/moflip-bucket/jakmania-app/the-jak.png"
          />

          <i
            style="
                position: relative;
                letter-spacing: 0.02em;
                line-height: 190%;
                font-weight: 500;
                z-index: 2;
                color: ${registrationNumberColor};
              "
            >Nomor Pendaftaran: ${data?.registrationNumber}</i
          >
        </div>
        <div
          style="
            background-color: #fff;
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding: 8px 44px;
            box-sizing: border-box;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 6px;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 4px;
            "
          >
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                color: #1a1a1b;
                display: inline-block;
                width: 129px;
                flex-shrink: 0;
              "
            >
              Data Permohonan
            </div>
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                display: none;
              "
            >
              /
            </div>
            <i
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                display: none;
                font-weight: 600;
              "
              >Applicant Information</i
            >
          </div>
          <div
            style="
              align-self: stretch;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 10px;
              font-size: 11px;
              color: #191a1a;
            "
          >
            <div
              style="
                flex: 1;
                border-radius: 6px;
                border: 1px solid #dbdfe7;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                padding: 12px;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 8px;
              "
            >
              <img
                style="
                  position: relative;
                  width: 64px;
                  height: 80px;
                  object-fit: cover;
                "
                alt=""
                src="${data?.profileImage}"
              />
              <div
                style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  justify-content: flex-start;
                  gap: 8px;
                "
              >
                <div
                  style="
                    position: relative;
                    font-size: 10px;
                    line-height: 14px;
                    text-transform: uppercase;
                    font-weight: 500;
                    color: #f3790e;
                  "
                >
                  Menunggu Pembayaran
                </div>
                <div
                  style="
                    align-self: stretch;
                    overflow: hidden;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 10px;
                    "
                  >
                    <div
                      style="
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <i
                        class="fa-solid fa-location-dot"
                        style="
                      position: relative;
                      width: 14px;
                      height: 14px;
                      overflow: hidden;
                      color: ${grayColor};
                      padding-top: 2px;
                      flex-shrink: 0;
                    "
                      ></i>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        line-height: 130%;
                        text-transform: uppercase;
                        font-weight: 600;
                      "
                    >
                      ${data?.korwil?.name}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    align-self: stretch;
                    overflow: hidden;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                    "
                  >
                    <div
                      style="
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: flex-start;
                      "
                    >
                      <i
                        class="fa fa-id-card"
                        style="
                      position: relative;
                      width: 14px;
                      height: 14px;
                      overflow: hidden;
                      color: ${grayColor};
                      padding-top: 2px;
                      flex-shrink: 0;
                    "
                      ></i>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                      ${
                        data?.type === 'NEW' || data?.type === 'MANUAL NEW'
                          ? 'Pembuatan KTA Baru'
                          : 'Perpanjang KTA Lama'
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="
                align-self: stretch;
                border-radius: 6px;
                border: 1px solid #dbdfe7;
                box-sizing: border-box;
                width: 156px;
                overflow: hidden;
                flex-shrink: 0;
                display: none;
                flex-direction: column;
                padding: 12px;
                align-items: center;
                justify-content: center;
                gap: 8px;
                text-align: center;
              "
            >
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  justify-content: flex-start;
                  gap: 4px;
                "
              >
                <div
                  style="
                    align-self: stretch;
                    position: relative;
                    line-height: 130%;
                    font-weight: 600;
                  "
                >
                  KTA & Official T-Shirt The Jakmania
                </div>
                <div
                  style="
                    align-self: stretch;
                    position: relative;
                    line-height: 130%;
                    font-weight: 600;
                    color: #f3790e;
                  "
                >
                  150.000
                </div>
              </div>
              <div
                style="
                    align-self: stretch;
                    position: relative;
                    border-top: 1px solid ${grayColor};
                    box-sizing: border-box;
                    height: 1px;
                  "
              ></div>
              <img
                style="
                  position: relative;
                  border-radius: 5.33px;
                  width: 110px;
                  height: 110px;
                  object-fit: cover;
                "
                alt="qr"
                src=""
              />
            </div>
          </div>
        </div>
        <div
          style="
            background-color: #fff;
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding: 8px 44px;
            box-sizing: border-box;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 6px;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 4px;
            "
          >
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                color: #1a1a1b;
              "
            >
              Informasi Pemohon
            </div>
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                display: none;
              "
            >
              /
            </div>
            <i
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                display: none;
                font-weight: 600;
              "
              >Applicant Information</i
            >
          </div>
          <div
            style="
              align-self: stretch;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 10px;
              font-size: 10px;
              color: #8b8e99;
            "
          >
            <div
              style="
                flex: 1;
                border-radius: 6px;
                border: 1px solid #dbdfe7;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                padding: 12px;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 8px;
              "
            >
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: row;
                  align-items: flex-start;
                  justify-content: flex-start;
                "
              >
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Nama Lengkap
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Name</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        line-height: 130%;
                        font-weight: 600;
                      "
                    >
                      ${data?.fullname}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      NIK
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >NIK</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        line-height: 130%;
                        font-weight: 600;
                      "
                    >
                      ${data?.nik}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: row;
                  align-items: flex-start;
                  justify-content: flex-start;
                "
              >
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Umur
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Age</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                    ${
                      data?.birthDate
                        ? moment().diff(moment(data?.birthDate), 'years') +
                          ' Tahun'
                        : '-'
                    }
                    </div>
                  </div>
                </div>
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Ukuran Baju
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Clothes Size</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">${
                      data?.shirtSize
                    }</div>
                  </div>
                </div>
              </div>
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: row;
                  align-items: flex-start;
                  justify-content: flex-start;
                "
              >
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Alamat
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Address</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                      ${data?.address}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: row;
                  align-items: flex-start;
                  justify-content: flex-start;
                "
              >
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Provinsi
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Province</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                      ${data?.province}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Kotamadya / Kabupaten
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Regency</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                      ${data?.city}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: row;
                  align-items: flex-start;
                  justify-content: flex-start;
                "
              >
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Kecamatan
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >Subdistrict</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                      ${data?.district}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 2px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 4px;
                    "
                  >
                    <div
                      style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          color: ${grayColor};
                        "
                    >
                      Kelurahan / Desa
                    </div>
                    <div
                      style="
                        position: relative;
                        line-height: 120%;
                        font-weight: 500;
                        display: none;
                      "
                    >
                      /
                    </div>
                    <i
                      style="
                        position: relative;
                        line-height: 120%;
                        display: none;
                        font-weight: 500;
                      "
                      >District</i
                    >
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      display: flex;
                      flex-direction: row;
                      align-items: flex-start;
                      justify-content: flex-start;
                      font-size: 11px;
                      color: #191a1a;
                    "
                  >
                    <div style="position: relative; line-height: 130%">
                      ${data?.subdistrict}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="
                align-self: stretch;
                border-radius: 6px;
                border: 1px solid #dbdfe7;
                box-sizing: border-box;
                width: 156px;
                overflow: hidden;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                padding: 12px;
                align-items: center;
                justify-content: center;
                gap: 8px;
                text-align: center;
                font-size: 11px;
                color: #191a1a;
              "
            >
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  justify-content: flex-start;
                  gap: 4px;
                "
              >
                <div
                  style="
                    align-self: stretch;
                    position: relative;
                    line-height: 130%;
                    font-weight: 600;
                  "
                >
                  KTA & Official T-Shirt The Jakmania
                </div>
                <div
                  style="
                    align-self: stretch;
                    position: relative;
                    line-height: 130%;
                    font-weight: 600;
                    color: #f3790e;
                  "
                >
                  150.000
                </div>
              </div>
              <div
                style="
                    align-self: stretch;
                    position: relative;
                    border-top: 1px solid ${grayColor};
                    box-sizing: border-box;
                    height: 1px;
                  "
              ></div>
              <img
                style="
                  position: relative;
                  border-radius: 5.33px;
                  width: 110px;
                  height: 110px;
                  object-fit: cover;
                "
                alt=""
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/640px-QR_code_for_mobile_English_Wikipedia.svg.png"
              />
            </div>
          </div>
        </div>
        <div
          style="
            background-color: #fff;
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding: 8px 44px;
            box-sizing: border-box;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 10px;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 4px;
            "
          >
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                color: #1a1a1b;
              "
            >
              Syarat dan Ketentuan
            </div>
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                display: none;
              "
            >
              /
            </div>
            <i
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                display: none;
                font-weight: 600;
              "
              >Terms & Conditions</i
            >
          </div>
          <div
            style="
              width: 514px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 4px;
              font-size: 11px;
              color: #191a1a;
            "
          >
            <div
              style="position: relative; line-height: 130%; font-weight: 600"
            >
              MOHON MEMBACA KETERANGAN DI BAWAH INI UNTUK MELAKUKAN VERIFIKASI PEMBAYARAN KTA THE JAKMANIA
            </div>
            <div
              style="
                align-self: stretch;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                font-size: inherit;
                font-family: inherit;
              "
            >
              <div
                style="
                  position: relative;
                  line-height: 130%;
                  display: inline-block;
                  width: 514px;
                "
              >
                <ul style="margin: 0; padding-left: 15px">
                  <li style="margin-bottom: 0px">
                    Untuk pendaftaran baru dan perpanjangan KTA lama, pendaftar wajib untuk
                    membayarkan biaya pendaftaran sebesar Rp150.000.
                  </li>
                  <li style="margin-bottom: 0px">
                    Pembayaran dan verifikasi pendaftaran dapat dilakukan secara langsung ke
                    Korwil sesuai dengan pilihan Wilayah/Biro the Jakmania dari masing-masing
                    pendaftar dengan membawa file digital (digital) atau kertas fisik bukti
                    pendaftaran. Alamat lengkap dan kontak Korwil berkaitan dapat dilihat pada
                    halaman Korwil aplikasi.
                  </li>
                  <li style="margin-bottom: 0px">
                    Setiap pendaftar yang sudah membayar biaya pendaftaran, berhak untuk
                    mendapatkan KTA digital (melalui aplikasi), KTA fisik (Mandiri E-Money), dan
                    T-Shirt Official Jakmania.
                  </li>
                  <li style="margin-bottom: 0px">
                    Foto dan data diri yang diupload pada form pendaftaran akan digunakan untuk
                    produksi KTA setiap pendaftar.
                  </li>
                  <li style="margin-bottom: 0px">
                    Size baju yang sudah dipilih pada pendaftaran, tidak dapat diganti dengan
                    alasan apapun.
                  </li>
                  <li style="margin-bottom: 0px">
                    Pendaftar yang telah melakukan pembayaran dan verifikasi ke Korwil akan
                    menunggu untuk mendapatkan persetujuan pendaftaran dari Pengurus Pusat the
                    Jakmania. Harap menunggu dan melakukan cek status pendaftaran pada halaman
                    “Profil” akun pendaftar.
                  </li>
                  <li style="margin-bottom: 0px">
                    Pendaftar yang telah mendapatkan persetujuan dari Pengurus Pusat the Jakmania
                    akan mendapatkan nomor anggota yang dapat dilihat pada aplikasi. Produksi KTA,
                    baju the Jakmania serta pengiriman KTA fisik akan dilakukan melalui setiap
                    Wilayah/Biro the Jakmania terkait.
                  </li>
                  <li style="margin-bottom: 0px">
                    Pihak the Jakmania berhak melakukan pembatalan pendaftaran pada pendaftar yang
                    memiliki data yang tidak valid dan melanggar syarat & ketentuan yang berlaku.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>
    <div
      style="
        position: relative;
        background-color: #fff;
        width: 100%;
        height: 842px;
        overflow: hidden;
        text-align: left;
        font-size: 14px;
        color: #8a8d97;
        font-family: 'Scoutie Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      "
    >
      <div
        style="
          width: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        "
      >
        <div
          style="
            background-color: #f3790e;
            width: 100%;
            height: 44px;
            overflow: hidden;
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            padding: 10px 12px;
            box-sizing: border-box;
            align-items: center;
            justify-content: space-between;
            position: relative;
            font-size: 10px;
            color: #fff;
          "
        >
          <div
            style="
              margin: 0 !important;
              position: absolute;
              top: 0px;
              left: 0px;
              display: flex;
              flex-direction: row;
              width: 100%;
              z-index: 0;
            "
          >
            <img
              style="
                position: relative;
                height: 44px;
                overflow: hidden;
                flex-shrink: 0;
                mix-blend-mode: soft-light;
              "
              src="https://nos.wjv-1.neo.id/moflip-bucket/jakmania-app/pdf-top-texture.svg"
            />
          </div>
          <img
            style="
              position: relative;
              width: 80px;
              height: 32px;
              object-fit: cover;
              z-index: 1;
            "
            alt=""
            src="https://nos.wjv-1.neo.id/moflip-bucket/jakmania-app/the-jak.png"
          />

          <i
            style="
                position: relative;
                letter-spacing: 0.02em;
                line-height: 190%;
                font-weight: 500;
                z-index: 2;
                color: ${registrationNumberColor};
              "
            >Nomor Pendaftaran: ${data?.registrationNumber}</i
          >
        </div>

        <div
          style="
            background-color: #fff;
            width: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding: 8px 44px;
            box-sizing: border-box;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 6px;
            font-size: 14px;
            color: #8a8d97;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 4px;
            "
          >
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                color: #1a1a1b;
              "
            >
              Dokumen Legal Pendaftar
            </div>
            <div
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                font-weight: 600;
                display: none;
              "
            >
              /
            </div>
            <i
              style="
                position: relative;
                letter-spacing: -0.02em;
                line-height: 140%;
                display: none;
                font-weight: 600;
              "
              >Applicant Information</i
            >
          </div>
          <div
            style="
              align-self: stretch;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
            "
          >
            <div
              style="
                flex: 1;
                border-radius: 6px;
                border: 1px solid #dbdfe7;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                padding: 12px;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                style="
                  position: relative;
                  width: 396.62px;
                  height: 248.23px;
                  object-fit: cover;
                "
                alt=""
                src=${data?.ktpImage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
  <style>
    @page print {
      .pagebreak {
        break-before: page;
      }
    }
    @media print {
      .pagebreak {
        break-before: page;
      }
    }
    @page print {
      .pagebreak {
        page-break-before: always;
      }
    }
    @media print {
      .pagebreak {
        break-before: always;
      }
    }
  </style>
</html>
`

export const pdfTemplateWithoutDocument = (
  data,
  registrationNumberColor = `#fff`,
  grayColor = `#ADB6C9`,
) => `<html>
  <body>
    <div>
      <div
        style="
          position: relative;
          background-color: #fff;
          width: 100%;
          height: 842px;
          overflow: hidden;
          text-align: left;
          font-size: 14px;
          color: #8a8d97;
          font-family: 'Scoutie Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        "
      >
        <div
          style="
            width: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
          "
        >
          <div
            style="
              background-color: #f3790e;
              width: 100%;
              height: 44px;
              overflow: hidden;
              flex-shrink: 0;
              display: flex;
              flex-direction: row;
              padding: 10px 12px;
              box-sizing: border-box;
              align-items: center;
              justify-content: space-between;
              position: relative;
              font-size: 10px;
              color: #fff;
            "
          >
            <div
              style="
                background-color: #f3790e;
                margin: 0 !important;
                position: absolute;
                top: 0px;
                left: 0px;
                display: flex;
                flex-direction: row;
                width: 100%;
                z-index: 0;
              "
            >
              <img
                style="
                  object-fit: cover;
                  width: 100%;
                  position: relative;
                  height: 44px;
                  overflow: hidden;
                  flex-shrink: 0;
                  mix-blend-mode: soft-light;
                "
                src="https://nos.wjv-1.neo.id/moflip-bucket/jakmania-app/pdf-top-texture.svg"
              />
            </div>
            <img
              style="
                position: relative;
                width: 80px;
                height: 32px;
                object-fit: cover;
                z-index: 1;
              "
              alt=""
              src="https://nos.wjv-1.neo.id/moflip-bucket/jakmania-app/the-jak.png"
            />
  
            <i
              style="
                  position: relative;
                  letter-spacing: 0.02em;
                  line-height: 190%;
                  font-weight: 500;
                  z-index: 2;
                  color: ${registrationNumberColor};
                "
              >Nomor Pendaftaran: ${data?.registrationNumber}</i
            >
          </div>
          <div
            style="
              background-color: #fff;
              width: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              padding: 8px 44px;
              box-sizing: border-box;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 6px;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 4px;
              "
            >
              <div
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  font-weight: 600;
                  color: #1a1a1b;
                  display: inline-block;
                  width: 129px;
                  flex-shrink: 0;
                "
              >
                Data Permohonan
              </div>
              <div
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  font-weight: 600;
                  display: none;
                "
              >
                /
              </div>
              <i
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  display: none;
                  font-weight: 600;
                "
                >Applicant Information</i
              >
            </div>
            <div
              style="
                align-self: stretch;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 10px;
                font-size: 11px;
                color: #191a1a;
              "
            >
              <div
                style="
                  flex: 1;
                  border-radius: 6px;
                  border: 1px solid #dbdfe7;
                  overflow: hidden;
                  display: flex;
                  flex-direction: row;
                  padding: 12px;
                  align-items: flex-start;
                  justify-content: flex-start;
                  gap: 8px;
                "
              >
                <img
                  style="
                    position: relative;
                    width: 64px;
                    height: 80px;
                    object-fit: cover;
                  "
                  alt=""
                  src="${data?.profileImage}"
                />
                <div
                  style="
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 8px;
                  "
                >
                  <div
                    style="
                      position: relative;
                      font-size: 10px;
                      line-height: 14px;
                      text-transform: uppercase;
                      font-weight: 500;
                      color: #f3790e;
                    "
                  >
                    Menunggu Pembayaran
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      overflow: hidden;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 10px;
                      "
                    >
                      <div
                        style="
                          overflow: hidden;
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <i
                          class="fa-solid fa-location-dot"
                          style="
                        position: relative;
                        width: 14px;
                        height: 14px;
                        overflow: hidden;
                        color: ${grayColor};
                        padding-top: 2px;
                        flex-shrink: 0;
                      "
                        ></i>
                      </div>
                    </div>
                    <div
                      style="
                        flex: 1;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                      "
                    >
                      <div
                        style="
                          position: relative;
                          line-height: 130%;
                          text-transform: uppercase;
                          font-weight: 600;
                        "
                      >
                        ${data?.korwil?.name}
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      overflow: hidden;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                      "
                    >
                      <div
                        style="
                          overflow: hidden;
                          display: flex;
                          flex-direction: column;
                          align-items: flex-start;
                          justify-content: flex-start;
                        "
                      >
                        <i
                          class="fa fa-id-card"
                          style="
                        position: relative;
                        width: 14px;
                        height: 14px;
                        overflow: hidden;
                        color: ${grayColor};
                        padding-top: 2px;
                        flex-shrink: 0;
                      "
                        ></i>
                      </div>
                    </div>
                    <div
                      style="
                        flex: 1;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                        ${
                          data?.type === 'NEW' || data?.type === 'MANUAL NEW'
                            ? 'Pembuatan KTA Baru'
                            : 'Perpanjang KTA Lama'
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="
                  align-self: stretch;
                  border-radius: 6px;
                  border: 1px solid #dbdfe7;
                  box-sizing: border-box;
                  width: 156px;
                  overflow: hidden;
                  flex-shrink: 0;
                  display: none;
                  flex-direction: column;
                  padding: 12px;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  text-align: center;
                "
              >
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 4px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      position: relative;
                      line-height: 130%;
                      font-weight: 600;
                    "
                  >
                    KTA & Official T-Shirt The Jakmania
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      position: relative;
                      line-height: 130%;
                      font-weight: 600;
                      color: #f3790e;
                    "
                  >
                    150.000
                  </div>
                </div>
                <div
                  style="
                      align-self: stretch;
                      position: relative;
                      border-top: 1px solid ${grayColor};
                      box-sizing: border-box;
                      height: 1px;
                    "
                ></div>
                <img
                  style="
                    position: relative;
                    border-radius: 5.33px;
                    width: 110px;
                    height: 110px;
                    object-fit: cover;
                  "
                  alt="qr"
                  src=""
                />
              </div>
            </div>
          </div>
          <div
            style="
              background-color: #fff;
              width: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              padding: 8px 44px;
              box-sizing: border-box;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 6px;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 4px;
              "
            >
              <div
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  font-weight: 600;
                  color: #1a1a1b;
                "
              >
                Informasi Pemohon
              </div>
              <div
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  font-weight: 600;
                  display: none;
                "
              >
                /
              </div>
              <i
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  display: none;
                  font-weight: 600;
                "
                >Applicant Information</i
              >
            </div>
            <div
              style="
                align-self: stretch;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 10px;
                font-size: 10px;
                color: #8b8e99;
              "
            >
              <div
                style="
                  flex: 1;
                  border-radius: 6px;
                  border: 1px solid #dbdfe7;
                  overflow: hidden;
                  display: flex;
                  flex-direction: column;
                  padding: 12px;
                  align-items: flex-start;
                  justify-content: flex-start;
                  gap: 8px;
                "
              >
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-start;
                    justify-content: flex-start;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Nama Lengkap
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Name</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div
                        style="
                          position: relative;
                          line-height: 130%;
                          font-weight: 600;
                        "
                      >
                        ${data?.fullname}
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        NIK
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >NIK</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div
                        style="
                          position: relative;
                          line-height: 130%;
                          font-weight: 600;
                        "
                      >
                        ${data?.nik}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-start;
                    justify-content: flex-start;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Umur
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Age</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                      ${
                        data?.birthDate
                          ? moment().diff(moment(data?.birthDate), 'years') +
                            ' Tahun'
                          : '-'
                      }
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Ukuran Baju
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Clothes Size</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">${
                        data?.shirtSize
                      }</div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-start;
                    justify-content: flex-start;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Alamat
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Address</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                        ${data?.address}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-start;
                    justify-content: flex-start;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Provinsi
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Province</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                        ${data?.province}
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Kotamadya / Kabupaten
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Regency</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                        ${data?.city}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-start;
                    justify-content: flex-start;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Kecamatan
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >Subdistrict</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                        ${data?.district}
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      overflow: hidden;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: flex-start;
                      gap: 2px;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        gap: 4px;
                      "
                    >
                      <div
                        style="
                            position: relative;
                            line-height: 120%;
                            font-weight: 500;
                            color: ${grayColor};
                          "
                      >
                        Kelurahan / Desa
                      </div>
                      <div
                        style="
                          position: relative;
                          line-height: 120%;
                          font-weight: 500;
                          display: none;
                        "
                      >
                        /
                      </div>
                      <i
                        style="
                          position: relative;
                          line-height: 120%;
                          display: none;
                          font-weight: 500;
                        "
                        >District</i
                      >
                    </div>
                    <div
                      style="
                        align-self: stretch;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-start;
                        justify-content: flex-start;
                        font-size: 11px;
                        color: #191a1a;
                      "
                    >
                      <div style="position: relative; line-height: 130%">
                        ${data?.subdistrict}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="
                  align-self: stretch;
                  border-radius: 6px;
                  border: 1px solid #dbdfe7;
                  box-sizing: border-box;
                  width: 156px;
                  overflow: hidden;
                  flex-shrink: 0;
                  display: flex;
                  flex-direction: column;
                  padding: 12px;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  text-align: center;
                  font-size: 11px;
                  color: #191a1a;
                "
              >
                <div
                  style="
                    align-self: stretch;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 4px;
                  "
                >
                  <div
                    style="
                      align-self: stretch;
                      position: relative;
                      line-height: 130%;
                      font-weight: 600;
                    "
                  >
                    KTA & Official T-Shirt The Jakmania
                  </div>
                  <div
                    style="
                      align-self: stretch;
                      position: relative;
                      line-height: 130%;
                      font-weight: 600;
                      color: #f3790e;
                    "
                  >
                    150.000
                  </div>
                </div>
                <div
                  style="
                      align-self: stretch;
                      position: relative;
                      border-top: 1px solid ${grayColor};
                      box-sizing: border-box;
                      height: 1px;
                    "
                ></div>
                <img
                  style="
                    position: relative;
                    border-radius: 5.33px;
                    width: 110px;
                    height: 110px;
                    object-fit: cover;
                  "
                  alt=""
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/640px-QR_code_for_mobile_English_Wikipedia.svg.png"
                />
              </div>
            </div>
          </div>
          <div
            style="
              background-color: #fff;
              width: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              padding: 8px 44px;
              box-sizing: border-box;
              align-items: flex-start;
              justify-content: flex-start;
              gap: 10px;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 4px;
              "
            >
              <div
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  font-weight: 600;
                  color: #1a1a1b;
                "
              >
                Syarat dan Ketentuan
              </div>
              <div
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  font-weight: 600;
                  display: none;
                "
              >
                /
              </div>
              <i
                style="
                  position: relative;
                  letter-spacing: -0.02em;
                  line-height: 140%;
                  display: none;
                  font-weight: 600;
                "
                >Terms & Conditions</i
              >
            </div>
            <div
              style="
                width: 514px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 4px;
                font-size: 11px;
                color: #191a1a;
              "
            >
              <div
                style="position: relative; line-height: 130%; font-weight: 600"
              >
              MOHON MEMBACA KETERANGAN DI BAWAH INI UNTUK MELAKUKAN VERIFIKASI PEMBAYARAN KTA THE JAKMANIA
              </div>
              <div
                style="
                  align-self: stretch;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  justify-content: flex-start;
                  font-size: inherit;
                  font-family: inherit;
                "
              >
                <div
                  style="
                    position: relative;
                    line-height: 130%;
                    display: inline-block;
                    width: 514px;
                  "
                >
                  <ul style="margin: 0; padding-left: 15px">
                    <li style="margin-bottom: 0px">
                      Untuk pendaftaran baru dan perpanjangan KTA lama, pendaftar wajib untuk
                      membayarkan biaya pendaftaran sebesar Rp150.000.
                    </li>
                    <li style="margin-bottom: 0px">
                      Pembayaran dan verifikasi pendaftaran dapat dilakukan secara langsung ke
                      Korwil sesuai dengan pilihan Wilayah/Biro the Jakmania dari masing-masing
                      pendaftar dengan membawa file digital (digital) atau kertas fisik bukti
                      pendaftaran. Alamat lengkap dan kontak Korwil berkaitan dapat dilihat pada
                      halaman Korwil aplikasi.
                    </li>
                    <li style="margin-bottom: 0px">
                      Setiap pendaftar yang sudah membayar biaya pendaftaran, berhak untuk
                      mendapatkan KTA digital (melalui aplikasi), KTA fisik (Mandiri E-Money), dan
                      T-Shirt Official Jakmania.
                    </li>
                    <li style="margin-bottom: 0px">
                      Foto dan data diri yang diupload pada form pendaftaran akan digunakan untuk
                      produksi KTA setiap pendaftar.
                    </li>
                    <li style="margin-bottom: 0px">
                      Size baju yang sudah dipilih pada pendaftaran, tidak dapat diganti dengan
                      alasan apapun.
                    </li>
                    <li style="margin-bottom: 0px">
                      Pendaftar yang telah melakukan pembayaran dan verifikasi ke Korwil akan
                      menunggu untuk mendapatkan persetujuan pendaftaran dari Pengurus Pusat the
                      Jakmania. Harap menunggu dan melakukan cek status pendaftaran pada halaman
                      “Profil” akun pendaftar.
                    </li>
                    <li style="margin-bottom: 0px">
                      Pendaftar yang telah mendapatkan persetujuan dari Pengurus Pusat the Jakmania
                      akan mendapatkan nomor anggota yang dapat dilihat pada aplikasi. Produksi KTA,
                      baju the Jakmania serta pengiriman KTA fisik akan dilakukan melalui setiap
                      Wilayah/Biro the Jakmania terkait.
                    </li>
                    <li style="margin-bottom: 0px">
                      Pihak the Jakmania berhak melakukan pembatalan pendaftaran pada pendaftar yang
                      memiliki data yang tidak valid dan melanggar syarat & ketentuan yang berlaku.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
    <style>
      @page print {
        .pagebreak {
          break-before: page;
        }
      }
      @media print {
        .pagebreak {
          break-before: page;
        }
      }
      @page print {
        .pagebreak {
          page-break-before: always;
        }
      }
      @media print {
        .pagebreak {
          break-before: always;
        }
      }
    </style>
  </html>
  `
